import getters from "./getters";
import actions from "./actions";
import * as types from "./../../action-types";
import { cloneDeep, findIndex } from "lodash";
import Vue from "vue";

// Candidate to make it global, this is the only way I found an
// object is copied completely
const vClone = (object) => Vue.util.extend({}, object);

const initialState = () =>
  cloneDeep({
    location: {
      list: [],
      devices: [],
      customers: [],
      location_devices: [],
      location_users: [],
      location_sos: [],
    },
  });

const mutations = {
  [types.FETCH_ACCOUNT_LOCATIONS.SUCCESS](state, response) {
    const {
      user_locations: list,
      location_users,
      location_smb_users,
      location_sos,
      location_devices,
      customers,
      devices,
    } = response;

    state.location = {
      list,
      location_users,
      location_smb_users,
      location_sos,
      location_devices,
      customers,
      devices,
    };
  },
  [types.FETCH_ACCOUNT_LOCATIONS.ERROR](state, error) {
    state.location = {
      list: [],
      devices: [],
      customers: [],
      location_devices: [],
      location_users: [],
      location_smb_users: [],
    };
  },
  [types.ADD_DEVICE_USER.SUCCESS](state, { user_id, device }) {
    let customer = state.location.location_users.find(
      (user) =>
        user.user_id == user_id && user.location_id === device.location_id
    );
    let linked_device = state.location.location_devices.find(
      (d) =>
        d.doorbot_id === device.doorbot_id &&
        d.location_id === device.location_id
    );
    customer.devices.push(linked_device);
  },
  [types.REMOVE_DEVICE_USER.SUCCESS](
    state,
    { user_id, device_id, location_id }
  ) {
    let customer = state.location.location_users.find(
      (user) => user.user_id == user_id && user.location_id == location_id
    );
    let device = customer.devices.find((dev) => dev.doorbot_id == device_id);
    if (device) {
      let index = findIndex(customer.devices, (dev) => {
        return dev.doorbot_id === device.doorbot_id;
      });
      customer.devices.splice(index, 1);
    }
  },
  [types.UPDATE_DEVICE_SETTINGS.SUCCESS](state, device) {
    const devices = state.location.devices.map((d) => {
      if (device.mac_address === d.mac_address) return vClone(device);
      return d;
    });
    let newLocation = vClone(state.location);
    newLocation.devices = devices;
    state.location = newLocation;
  },
  resetState(state) {
    Object.assign(state, initialState());
  },
  SET_LOCATION_AUTHORIZED_USERS(state, { locationId, authorizedUsers }) {
    if (!state.location || !state.location.list) return;

    const locationIndex = state.location.list.findIndex(
      (location) => location.location_id === locationId
    );

    if (locationIndex !== -1) {
      // Create a new object to maintain reactivity
      const updatedLocation = { ...state.location.list[locationIndex] };
      updatedLocation.authorized_users = authorizedUsers;

      // Replace the location in the array to maintain reactivity
      Vue.set(state.location.list, locationIndex, updatedLocation);
    }
  },
};

export default {
  state: initialState(),
  mutations,
  getters,
  actions,
  namespaced: true,
};
